import {Table} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {addCount, removeCount, sortName, sortName2} from "./../store.js";
import Button from "react-bootstrap/Button";

function Cart() {
    let state = useSelector((state) => state);
    console.log(state)
  let dispatch = useDispatch(); //4. useDispatch() import하고 사용
  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>#</th>
            <th>상품명</th>
            <th>수량</th>
            <th>변경하기</th>
          </tr>
        </thead>
        <tbody>
          {state.cart.map((v, i) => (
            <tr key={i}>
              <td>{state.cart[i].id}</td>
              <td>{state.cart[i].name}</td>
              <td>{state.cart[i].count}</td>
              <td>
                <Button onClick={() => dispatch(addCount(state.cart[i].id))}>+</Button> <Button onClick={() => dispatch(removeCount(state.cart[i].id))}>-</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Button
        variant="outline-primary"
        onClick={() => {
          dispatch(sortName(state.cart.Name));
        }}
      >
        이름순 정렬
      </Button>{" "}
      <Button
        variant="outline-primary"
        onClick={() => {
          dispatch(sortName2(state.cart.id));
        }}
      >
        주문순 정렬
      </Button>
    </>
  );
}
export default Cart;
